export type OtpChannels = {
  email: boolean;
  mobile: boolean;
};

/** Location state used when registration auto-login already issued a login OTP. */
export type PendingLoginOtpState = {
  sessionId: string;
  channels: OtpChannels;
  email?: string;
  message?: string;
};

const REGISTRATION_OTP_PATTERN = /^\d{6}$/;

export const isValidRegistrationOtp = (value: string): boolean =>
  REGISTRATION_OTP_PATTERN.test(String(value || '').trim());

const channelSent = (value: unknown): boolean => {
  if (value && typeof value === 'object' && 'sent' in (value as { sent?: unknown })) {
    return Boolean((value as { sent?: unknown }).sent);
  }
  return Boolean(value);
};

/**
 * Normalize OTP channel flags from API payloads.
 * Uses channels that actually delivered OTP (`sent`), not merely enabled ones.
 * SMS is the default challenge — if channels are missing or both false,
 * fall back to mobile so the UI always exposes an OTP input.
 */
export function resolveOtpChannels(
  raw?: { email?: unknown; mobile?: unknown; sms?: unknown } | null,
): OtpChannels {
  const email = channelSent(raw?.email);
  const mobile = channelSent(raw?.mobile) || channelSent(raw?.sms);
  if (!email && !mobile) {
    return { email: false, mobile: true };
  }
  return { email, mobile };
}
